import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import SpeedIcon from '@mui/icons-material/Speed';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ImportExportIcon from '@mui/icons-material/ImportExport';

// Import diretti dei componenti
import ReadingEntryTab from '../components/readings/ReadingEntryTab';
import ReadingListTab from '../components/readings/ReadingListTab';
import BillingTab from '../components/readings/BillingTab';
import ReadingImportExportTab from '../components/readings/ReadingImportExportTab';

// Tab panel component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`readings-tabpanel-${index}`}
      aria-labelledby={`readings-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const ReadingsPage = () => {
  const [tabValue, setTabValue] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 3 } }}>
      {/* Header */}
      <Box sx={{ mb: isMobile ? 1 : 3 }}>
        <Typography variant={isMobile ? 'h6' : 'h4'} fontWeight="bold" gutterBottom>
          <SpeedIcon sx={{ mr: 1, verticalAlign: 'middle', fontSize: isMobile ? 24 : 35 }} />
          Letture e Fatturazione
        </Typography>
        {!isMobile && <Typography variant="body1" color="text.secondary">
          Inserimento letture contatori e generazione fatture clienti
        </Typography>}
      </Box>

      {/* Tabs */}
      <Paper sx={{ mb: isMobile ? 1 : 3 }}>
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant={isMobile ? 'scrollable' : 'fullWidth'}
          scrollButtons={isMobile ? 'auto' : false}
          allowScrollButtonsMobile
        >
          <Tab 
            icon={<SpeedIcon />} 
            label={isMobile ? 'Letture' : 'Inserimento Letture'} 
            iconPosition="start"
          />
          <Tab
            icon={<ListAltIcon />}
            label={isMobile ? 'Archivio' : 'Archivio Letture'}
            iconPosition="start"
          />
          <Tab
            icon={<ReceiptLongIcon />}
            label={isMobile ? 'Fatture' : 'Emissione Fatture'}
            iconPosition="start"
          />
          <Tab
            icon={<ImportExportIcon />}
            label={isMobile ? 'Import' : 'Import/Export Letture'}
            iconPosition="start"
          />
        </Tabs>
      </Paper>

      {/* Tab Panels */}
      <TabPanel value={tabValue} index={0}>
        <ReadingEntryTab />
      </TabPanel>
      
      <TabPanel value={tabValue} index={1}>
        <ReadingListTab />
      </TabPanel>
      
      <TabPanel value={tabValue} index={2}>
        <BillingTab />
      </TabPanel>
      
      <TabPanel value={tabValue} index={3}>
        <ReadingImportExportTab />
      </TabPanel>
    </Box>
  );
};

export default ReadingsPage;
